import "./Input.css";

const CONDITIONS_TEXT = "أوافق على شروط الاستخدام";

function Input({ field, value, error, onChange }) {
  const {
    autoComplete,
    fieldName,
    id,
    isCheckbox,
    label,
    max,
    maxLength,
    min,
    minLength,
    placeholder,
    required,
    rows,
    step,
    text,
    type,
    value: optionValue,
  } = field;

  if (isCheckbox) {
    const isConditionsField = type === "conditions";

    return (
      <div className="lp-form-field lp-form-checkbox-field">
        <label className="lp-form-checkbox">
          <input
            checked={Boolean(value)}
            name={fieldName}
            onChange={(event) => onChange(event.target.checked)}
            required={isConditionsField || required !== false}
            type="checkbox"
          />
          <span>
            {isConditionsField ? (
              <>
                أنا موافق على{" "}
                <a
                  href="/legal/terms.html"
                  onClick={(event) => event.stopPropagation()}
                  rel="noopener"
                  target="_blank"
                >
                  شروط الاستخدام والمشاركة
                </a>
                {" "}
                <span>و</span>
                <a
                  href="/legal/privacy-policy.html"
                  onClick={(event) => event.stopPropagation()}
                  rel="noopener"
                  target="_blank"
                >
                  سياسة الخصوصية
                </a>
                ، وأؤكد أنني أبلغ 18 عامًا أو أكثر، وأوافق على استخدام بياناتي
                الشخصية لغرض التسجيل في اللقاء والتواصل معي بشأنه.
              </>
            ) : (
              text || optionValue || label || placeholder || CONDITIONS_TEXT
            )}
          </span>
        </label>
        {error && <span className="lp-form-error">{error}</span>}
      </div>
    );
  }

  const inputId = id || `lp-form-${fieldName}`;
  const controlProps = {
    "aria-invalid": Boolean(error),
    autoComplete: autoComplete || fieldName,
    id: inputId,
    max,
    maxLength,
    min,
    minLength,
    name: fieldName,
    onChange: (event) => onChange(event.target.value),
    placeholder: placeholder || "",
    required: required !== false,
    step,
    value: value ?? "",
  };

  return (
    <div className="lp-form-field">
      {label && <label htmlFor={inputId}>{label}</label>}

      {type === "textarea" ? (
        <textarea {...controlProps} rows={rows || 4} />
      ) : (
        <input
          {...controlProps}
          type={type === "phone" ? "tel" : type}
        />
      )}

      {error && <span className="lp-form-error">{error}</span>}
    </div>
  );
}

export default Input;
